import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle, Clock, FileText } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const STATUS_LABEL = {
  bozza: "Pratica avviata — la consulenza non è ancora stata generata.",
  in_lavorazione: "Consulenza in preparazione — sarà disponibile a breve.",
};

export default function RetePratica() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, error: "", data: null });

  useEffect(() => {
    document.title = "Pratica · Torri.Solar";
    axios.get(`${API}/api/rete/pratica/${token}`)
      .then((r) => {
        const d = r.data || {};
        if (d.consulenza_path) {
          window.location.replace(d.consulenza_path);
          return;
        }
        setState({ loading: false, error: "", data: d });
      })
      .catch((e) => {
        const msg = e.response?.status === 404 ? "Pratica non trovata o link non valido." : "Impossibile aprire la pratica.";
        setState({ loading: false, error: msg, data: null });
      });
  }, [token]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="rete-pratica-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (state.error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="rete-pratica-error">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-10 w-10 text-destructive mx-auto mb-3" />
          <h1 className="font-heading font-bold text-lg mb-1">Link non disponibile</h1>
          <p className="text-sm text-muted-foreground">{state.error}</p>
        </div>
      </div>
    );
  }

  const d = state.data || {};
  const inst = d.installer || {};
  const partner = d.brand_mode === "partner";

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="rete-pratica-pending">
      <div className="border-b border-border bg-background/95 backdrop-blur px-4 sm:px-6 py-3">
        <div className="mx-auto max-w-3xl flex items-center justify-between gap-4">
          {partner && inst.ragione_sociale ? (
            <div className="flex items-center gap-2.5">
              {inst.logo_url ? (
                <img src={inst.logo_url} alt={inst.ragione_sociale} className="h-10 w-10 rounded-lg object-contain bg-white border border-border" onError={(e) => { e.currentTarget.style.display = "none"; }} />
              ) : (
                <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center font-heading font-extrabold">{inst.ragione_sociale.charAt(0).toUpperCase()}</div>
              )}
              <div className="leading-tight">
                <div className="font-heading font-extrabold text-sm">{inst.ragione_sociale}</div>
                <div className="text-[10px] text-muted-foreground">{[inst.citta, inst.provincia].filter(Boolean).join(" · ")}</div>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-9 w-9 rounded-full object-contain" />
              <div className="font-heading font-extrabold text-sm tracking-wide">TORRI<span style={{ color: "#FDD003" }}>.SOLAR</span></div>
            </div>
          )}
          {partner && (
            <div className="flex items-center gap-2">
              <img src="/torri-icon.png" alt="TORRI.SOLAR" className="h-7 w-7 rounded-full object-contain" />
              <span className="text-[10px] font-semibold uppercase tracking-wide text-primary bg-primary/10 rounded-full px-2 py-0.5">{d.partner_note}</span>
            </div>
          )}
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-md text-center">
          <div className="h-14 w-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mx-auto mb-4">
            <Clock className="h-7 w-7" />
          </div>
          <h1 className="font-heading font-extrabold text-2xl mb-2">Consulenza in preparazione</h1>
          <p className="text-sm text-muted-foreground">
            {STATUS_LABEL[d.status] || "La consulenza non è ancora disponibile per questa pratica."}
            {d.consumer_name ? <> <br />Cliente: <b className="text-foreground">{d.consumer_name}</b></> : null}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-xs text-muted-foreground">
            <FileText className="h-4 w-4" /> Il link si aprirà automaticamente quando la consulenza sarà pronta.
          </div>
        </div>
      </div>
    </div>
  );
}
